@import "~/styles/variables";

.SidebarTabs {
  width: $space-m * 10;

  .Separator {
    border-bottom: $border-standard;
    margin-bottom: $space-xs;
    margin-top: $space-s;
  }

  .Item {
    @include border-radius("s");
    @include font-size("s");
    @include font-weight("semibold");
    @include pad("xs");
    cursor: pointer;

    &_active {
      @include font-color("white");
      background: $color-charcoal-light;
      cursor: default;
    }
  }
}
